"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
const UndergroundToken_vue_1 = __importDefault(require("@/client/components/underworld/UndergroundToken.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'SelectClaimedUndergroundToken',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            selected: [],
        };
    },
    components: {
        AppButton: AppButton_vue_1.default,
        UndergroundToken: UndergroundToken_vue_1.default,
    },
    methods: {
        canSave() {
            if (this.selected.length > this.playerinput.max) {
                return false;
            }
            if (this.selected.length < this.playerinput.min) {
                return false;
            }
            return true;
        },
        saveData() {
            this.onsave({ type: 'claimedUndergroundToken', selected: this.selected.sort() });
        },
    },
});
